import { treeSetRequestSchema } from './generated/zod/treeSetRequestSchema';

/** `.nullish()` contributes two; bounded so a generator change cannot make this an unbounded walk. */
const MAX_WRAPPER_DEPTH = 4;

/** Walked rather than unwrapped a fixed number of times, which would read `undefined` and yield no fields. */
const orderContractDescription = (): string => {
  let node: unknown = treeSetRequestSchema.shape.order;
  for (let depth = 0; depth <= MAX_WRAPPER_DEPTH; depth += 1) {
    const { description } = node as { description?: unknown };
    if (typeof description === 'string') return description;
    const { unwrap } = node as { unwrap?: unknown };
    if (typeof unwrap !== 'function') break;
    node = (unwrap as () => unknown).call(node);
  }
  return '';
};

/**
 * Order fields reporting-store can execute, scraped from the contract's docs since `order` is a sort
 * expression, not an enum. Interim — belongs behind a capability endpoint, as item-store's `GET /items/fields`.
 */
export const REPORTING_STORE_ORDER_FIELDS: ReadonlySet<string> = new Set(
  [...orderContractDescription().matchAll(/^- `([^`]+)`/gm)].map(([, field]) => field as string),
);
